import React, { useState, useRef } from "react";

export default function MoreBadge({ items, type, count }) {
  const [isOpen, setIsOpen] = useState(false);
  const timeoutRef = useRef(null);

  const handleMouseEnter = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsOpen(false);
    }, 200);
  };

  const handleClick = (e) => {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  return (
    <div
      className="members-more-wrapper"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      <span className="members-chip-more">+{count} more</span>
      {isOpen && (
        <div className="members-more-dropdown">
          <div className="members-more-list">
            {items.map((item, idx) =>
              type === "project" ? (
                <a
                  key={idx}
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="members-more-item project"
                >
                  {item}
                </a>
              ) : (
                <span key={idx} className="members-more-item">
                  {item}
                </span>
              ),
            )}
          </div>
        </div>
      )}
    </div>
  );
}
